import React from "react";

// const PDF_ASPECT_RATIO = 21.01 / 29.71;
export const PDF_ASPECT_RATIO = 0.70918883;

export default function CertPreview({
	src,
	width = 300,
	style = null,
	...rest
}) {
	const modifiedSrc = src + "?#toolbar=0&navpanes=0";
	// const modifiedSrc = "https://fca-tms.test/jtcpdf/report/fcacert/TIKTOK_47598_LIM_HUI_PING_2024-07-10.pdf?" + "?#toolbar=0&navpanes=0";


	if (src && src.includes(".pdf")) {
		return <iframe
			src={modifiedSrc}
			style={{ width, aspectRatio: PDF_ASPECT_RATIO, ...(style ? style : {}) }}
			{...rest}
		/>
	}

	return <img
		src={src}
		width={width}
		style={{
			aspectRatio: PDF_ASPECT_RATIO,
			objectFit: "contain",
			backgroundColor: "white",
			...style,
		}}
		{...rest}
	/>
}